<template>
  <main
    class="main animated fadeIn faster"
    :class="{ 'expand-main': isMenuCollapse }"
  >
    <div class="embed-responsive embed-responsive-16by9">
      <iframe
        src="https://adaptive-nectarine-029.notion.site/ebd/2556c45e956880f6ba5ed1c247c33cbb"
        width="100%"
        height="600"
        frameborder="0"
        allowfullscreen
      >
      </iframe>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "bookerAcademy",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
  },
};
</script>

